import type { SingleValueFilter } from '@/scopes/checkout/filterableCars/domain/types'
import type { FilterMapper } from '@/scopes/checkout/filterableCars/domain/types/filterMappers'
import type { APIFilterableCarFilter } from '@/scopes/checkout/filterableCars/infrastructure/api/types'

export const defaultSelected = 'all'

export const createSingleValueFilterMapper: () => FilterMapper<SingleValueFilter> = () => {
  function map(filtersFromApi: APIFilterableCarFilter) {
    if (!filtersFromApi || filtersFromApi.values.length === 0)
      return null

    return {
      type: filtersFromApi.type,
      selectedFilter: mapSelectedFilter(filtersFromApi),
      filterOptions: [
        {
          name: 'All Cars',
          value: defaultSelected,
          quantity: filtersFromApi.values.reduce((sum, item) => sum + item.quantity, 0),
          startingPrice: null,
        },
        ...filtersFromApi.values.map(value => ({
          name: value.name,
          value: value.value,
          quantity: value.quantity !== 0 ? value.quantity : null,
          startingPrice: value.startingPrice,
        })),
      ],
    }
  }

  function mapSelectedFilter(filtersFromApi: APIFilterableCarFilter) {
    return filtersFromApi.values.find(value => value.isSelected)?.value ?? defaultSelected
  }

  function mapSelection(filter: SingleValueFilter) {
    const { filterOptions, selectedFilter } = filter

    return filterOptions
      .filter(option => option.value !== defaultSelected)
      .map((option) => {
        return {
          value: option.value,
          name: option.name,
          selected: option.value === selectedFilter,
        }
      })
  }

  return {
    map,
    mapSelection,
  }
}
